module.exports = __webpack_public_path__ + "media/proksee-viewer/images/cgview_logo-dd3ab21fcf82990b364f4c559e512417.png";